export const translations = {
  pt: {
    nav: {
      home: 'Início', about: 'Sobre', services: 'Serviços', news: 'Notícias',
      events: 'Eventos', faq: 'FAQ', contact: 'Contactos', payments: 'Taxas',
      login: 'Entrar', logout: 'Sair', backoffice: 'Backoffice', register: 'Registar',
      emergency: 'Emergência Consular', documents: 'Documentos',
      embassy: 'A Embaixada',
      embassy_desc: 'Conheça a missão e estrutura da embaixada',
      diplomatic_corps: 'Corpo Diplomático',
      diplomatic_corps_desc: 'Embaixadora e equipa diplomática',
      consular_services: 'Serviços Consulares',
      consulate: 'O Consulado',
      angola_spain: 'Angola–Espanha',
      investment: 'Investimento',
      invest_angola: 'Investir em Angola',
      invest_angola_desc: 'Oportunidades e incentivos ao investimento',
      business_opportunities: 'Oportunidades de Negócio',
      business_opportunities_desc: 'Sectores estratégicos e parcerias',
      bilateral_relations: 'Relações Bilaterais',
      bilateral_relations_desc: 'Cooperação Angola–Espanha',
      news_events: 'Notícias e Eventos',
    },
    home: {
      hero_title: 'Embaixada de Angola em Espanha',
      hero_subtitle: 'Ao serviço dos cidadãos angolanos e das relações bilaterais entre Angola e Espanha',
      hero_btn1: 'Serviços Consulares',
      hero_btn2: 'Pagar Taxas',
      services_title: 'Serviços Consulares',
      news_title: 'Últimas Notícias',
      events_title: 'Próximos Eventos',
      hours_title: 'Horário de Atendimento',
      view_all_services: 'Ver todos os serviços',
      schedule_appointment: 'Agendar Consulta',
      schedule_desc: 'Marque o seu atendimento online',
      consular_card: 'Cartão Consular',
      consular_card_desc: 'Solicite o seu cartão online',
      consular_services: 'Serviços Consulares',
      consular_services_desc: 'Consulte todos os serviços',
      read_article: 'Ler artigo',
    },
    common: {
      read_more: 'Ler mais', view_all: 'Ver todos', loading: 'A carregar...',
      save: 'Guardar', cancel: 'Cancelar', delete: 'Eliminar', edit: 'Editar',
      create: 'Criar', submit: 'Submeter', publish: 'Publicar', draft: 'Rascunho',
      approve: 'Aprovar', reject: 'Rejeitar', search: 'Pesquisar',
      date: 'Data', author: 'Autor', category: 'Categoria', status: 'Estado',
      back: 'Voltar', next: 'Próximo', previous: 'Anterior',
      confirm_delete: 'Tem a certeza que deseja eliminar?', yes: 'Sim', no: 'Não',
      required: 'Obrigatório', success: 'Sucesso', error: 'Erro',
      no_results: 'Nenhum resultado encontrado.',
      sending: 'A enviar...', free_entry: 'ENTRADA GRATUITA',
      learn_more: 'Saber Mais', other: 'Outros',
    },
    embassy: {
      overline: 'República de Angola',
      title: 'A Embaixada',
      subtitle: 'Representação diplomática de Angola no Reino de Espanha',
      stat_citizens: 'Cidadãos Angolanos em Espanha',
      stat_since: 'Relações Diplomáticas desde',
      stat_services: 'Serviços Consulares',
      about_overline: 'Sobre a Embaixada',
      about_title: 'A Nossa História e Missão',
      about_p1: 'A Embaixada da República de Angola em Madrid é a representação diplomática oficial da República de Angola junto ao Estado espanhol, com jurisdição em todo o território do Reino de Espanha.',
      about_p2: 'Fundada em 1982, a missão diplomática angolana em Espanha tem desempenhado um papel fundamental no fortalecimento das relações bilaterais entre os dois países, abrangendo áreas como cooperação económica, cultural, educativa e política.',
      about_p3: 'A Embaixada presta serviços consulares essenciais aos cidadãos angolanos residentes em Espanha, incluindo a emissão de passaportes, bilhetes de identidade, vistos, certidões e outros documentos oficiais.',
      info_title: 'Informações Práticas',
      contact_btn: 'Contactar a Embaixada',
      mission_title: 'A Nossa Missão',
      sectors_title: 'Sectores',
      sector_ambassador: 'Embaixadora',
      sector_consular: 'Sector Consular',
      sector_consular_desc: 'Passaportes, vistos, certidões e todos os serviços consulares para cidadãos angolanos',
      sector_political: 'Sector Político',
      sector_political_desc: 'Relações diplomáticas, cooperação bilateral e assuntos políticos internacionais',
      sector_economic: 'Sector Económico e Comercial',
      sector_economic_desc: 'Promoção do investimento, comércio bilateral e relações económicas Angola–Espanha',
      sector_communication: 'Sector da Comunicação',
      sector_communication_desc: 'Imprensa, eventos institucionais, relações públicas e comunicação digital',
    },
    diplomatic: {
      overline: 'Corpo Diplomático',
      title: 'Corpo Diplomático',
      subtitle: 'A equipa diplomática que representa Angola em Espanha',
      org_overline: 'Estrutura Organizacional',
      org_title: 'Organigrama da Embaixada',
      org_subtitle: 'A equipa que serve a comunidade angolana em Espanha',
      placeholder: 'A designar',
    },
    angola_spain: {
      overline: 'Relações Internacionais',
      title: 'Angola – Espanha',
      subtitle: 'Uma parceria estratégica para o desenvolvimento mútuo',
      relations_overline: 'Parceria Estratégica',
      relations_title: 'Relações Angola–Espanha',
      relations_p1: 'Angola e Espanha mantêm relações diplomáticas desde 1975, ano da independência angolana. Ao longo das décadas, a cooperação entre os dois países tem-se intensificado em diversas áreas estratégicas.',
      relations_p2: 'A comunidade angolana em Espanha, estimada em mais de 50 mil cidadãos, constitui uma ponte vital entre os dois países, contribuindo para o enriquecimento cultural e económico de ambas as nações.',
      stat_year: 'Relações desde',
      stat_community: 'Comunidade Angolana',
      stat_agreements: 'Acordos Bilaterais',
      stat_sectors: 'Sectores de Cooperação',
      areas_title: 'Áreas de Cooperação',
      area_economy: 'Economia e Comércio',
      area_economy_desc: 'Intercâmbio comercial e investimentos bilaterais entre empresas angolanas e espanholas.',
      area_culture: 'Cultura e Língua',
      area_culture_desc: 'Promoção da cultura angolana e intercâmbios culturais entre os dois países.',
      area_education: 'Educação e Formação',
      area_education_desc: 'Programas de bolsas, intercâmbio académico e cooperação universitária.',
      area_energy: 'Energia e Recursos',
      area_energy_desc: 'Cooperação nos sectores energético, petrolífero e de recursos naturais.',
      area_politics: 'Cooperação Política',
      area_politics_desc: 'Diálogo político, consultas bilaterais e posições conjuntas em fóruns internacionais.',
      area_tourism: 'Turismo',
      area_tourism_desc: 'Promoção turística bilateral e facilitação de viagens entre os dois países.',
      cta_title: 'Fortalecer as Relações',
      cta_desc: 'Descubra oportunidades de investimento e cooperação entre Angola e Espanha.',
      cta_invest: 'Investir em Angola',
      cta_contact: 'Contactar a Embaixada',
    },
    invest: {
      overline: 'Investimento',
      title: 'Investir em Angola',
      subtitle: 'Descubra as oportunidades de investimento num dos países com maior crescimento em África',
      why_title: 'Porquê Investir em Angola?',
      why_desc: 'Angola é a terceira maior economia da África Subsaariana, com vastos recursos naturais, uma população jovem e dinâmica, e um programa ambicioso de diversificação económica. O país oferece incentivos fiscais atrativos, zonas económicas especiais e um quadro legal favorável ao investimento estrangeiro.',
      advantages_title: 'Vantagens Competitivas',
      adv_1: 'Terceira maior economia da África Subsaariana',
      adv_2: 'Recursos naturais abundantes (petróleo, diamantes, minerais)',
      adv_3: 'População jovem e dinâmica (60% com menos de 25 anos)',
      adv_4: 'Incentivos fiscais e zonas económicas especiais',
      adv_5: 'Localização estratégica na costa atlântica africana',
      adv_6: 'Programas de diversificação económica em curso',
      sectors_title: 'Sectores Estratégicos',
      sector_oil: 'Petróleo e Gás',
      sector_oil_desc: 'Segundo maior produtor de petróleo em África, com vastas reservas offshore e programas de exploração em expansão.',
      sector_mining: 'Mineração e Diamantes',
      sector_mining_desc: 'Quarto maior produtor mundial de diamantes, com potencial significativo em ouro, ferro e outros minerais.',
      sector_agri: 'Agricultura',
      sector_agri_desc: 'Terras aráveis abundantes com potencial para culturas como café, algodão, sisal e produção alimentar.',
      sector_tech: 'Tecnologia',
      sector_tech_desc: 'Sector em rápida expansão com oportunidades em telecomunicações, fintech e transformação digital.',
      sector_infra: 'Infraestruturas',
      sector_infra_desc: 'Investimentos significativos em transportes, energia, habitação e infraestruturas urbanas.',
      sector_tourism: 'Turismo',
      sector_tourism_desc: 'Potencial inexplorado com paisagens únicas, fauna diversa e riqueza cultural.',
      cta_title: 'Pronto para Investir?',
      cta_desc: 'O Sector Económico e Comercial da Embaixada está disponível para apoiar o seu projecto de investimento em Angola.',
      cta_opportunities: 'Ver Oportunidades',
      cta_contact: 'Contactar-nos',
    },
    opportunities: {
      overline: 'Oportunidades',
      title: 'Oportunidades de Negócio',
      subtitle: 'Sectores estratégicos e oportunidades para investidores e empresas',
      intro_title: 'Oportunidades em Angola',
      intro_desc: 'O Governo de Angola tem implementado reformas estruturais significativas para atrair investimento estrangeiro. O Programa de Apoio à Produção, Diversificação das Exportações e Substituição das Importações (PRODESI) cria oportunidades em diversos sectores da economia.',
      sectors_title: 'Sectores com Oportunidades',
      opp_energy: 'Energia e Petróleo',
      opp_energy_desc: 'Concessões petrolíferas, energia renovável, refinação e distribuição de combustíveis.',
      opp_construction: 'Construção e Imobiliário',
      opp_construction_desc: 'Projectos habitacionais, infraestruturas públicas e desenvolvimento urbano.',
      opp_agriculture: 'Agro-indústria',
      opp_agriculture_desc: 'Produção alimentar, processamento agrícola e exportação de produtos tropicais.',
      opp_technology: 'Tecnologia e Inovação',
      opp_technology_desc: 'Telecomunicações, pagamentos digitais, e-commerce e serviços tecnológicos.',
      opp_finance: 'Serviços Financeiros',
      opp_finance_desc: 'Banca, seguros, micro-finanças e investimento de capital.',
      opp_services: 'Serviços e Consultoria',
      opp_services_desc: 'Consultoria jurídica, auditoria, formação profissional e serviços empresariais.',
      links_title: 'Ligações Úteis',
      cta_title: 'Interessado numa Oportunidade?',
      cta_desc: 'Contacte o Sector Económico e Comercial da Embaixada para mais informações.',
      cta_contact: 'Contactar a Embaixada',
    },
    bilateral: {
      overline: 'Diplomacia',
      title: 'Relações Bilaterais',
      subtitle: 'A história e cooperação entre Angola e Espanha',
      relations_overline: 'Parceria Estratégica',
      overview_title: 'Relações Angola–Espanha',
      overview_p1: 'As relações bilaterais entre Angola e Espanha são pautadas pela amizade, pelo respeito mútuo e pela vontade de cooperação em áreas estratégicas. Espanha foi um dos primeiros países europeus a reconhecer a independência de Angola em 1975.',
      overview_p2: 'A comunidade angolana em Espanha, estimada em mais de 50 mil cidadãos, constitui uma ponte vital entre os dois países, contribuindo para o enriquecimento cultural e económico de ambas as nações.',
      stat_year: 'Relações desde',
      stat_community: 'Comunidade Angolana',
      stat_agreements: 'Acordos Bilaterais',
      stat_sectors: 'Sectores de Cooperação',
      areas_title: 'Áreas de Cooperação',
      area_economy: 'Economia e Comércio',
      area_economy_desc: 'Intercâmbio comercial e investimentos bilaterais entre empresas angolanas e espanholas.',
      area_culture: 'Cultura e Língua',
      area_culture_desc: 'Promoção da cultura angolana e intercâmbios culturais entre os dois países.',
      area_education: 'Educação e Formação',
      area_education_desc: 'Programas de bolsas, intercâmbio académico e cooperação universitária.',
      area_energy: 'Energia e Recursos',
      area_energy_desc: 'Cooperação nos sectores energético, petrolífero e de recursos naturais.',
      area_politics: 'Cooperação Política',
      area_politics_desc: 'Diálogo político, consultas bilaterais e posições conjuntas em fóruns internacionais.',
      area_tourism: 'Turismo',
      area_tourism_desc: 'Promoção turística bilateral e facilitação de viagens entre os dois países.',
      timeline_title: 'Cronologia',
      timeline_1975: 'Independência de Angola. Espanha reconhece o novo Estado.',
      timeline_1982: 'Abertura da primeira Embaixada de Angola em Madrid.',
      timeline_2000: 'Assinatura de acordos de cooperação económica e comercial.',
      timeline_2010: 'Intensificação das relações económicas e investimentos bilaterais.',
      timeline_2025: 'Nomeação da nova Embaixadora e reforço da cooperação estratégica.',
      cta_title: 'Fortalecer a Parceria',
      cta_desc: 'A Embaixada trabalha diariamente para aprofundar as relações entre Angola e Espanha.',
      cta_invest: 'Investir em Angola',
      cta_contact: 'Contactar a Embaixada',
    },
    news_events: {
      overline: 'Comunicação',
      title: 'Notícias e Eventos',
      subtitle: 'Acompanhe as últimas notícias e eventos da Embaixada de Angola em Espanha',
      featured_news: 'Notícias em Destaque',
      articles: 'Artigos e Publicações',
      events_section: 'Próximos Eventos',
    },
    about: {
      republic: 'República de Angola',
      title: 'Embaixada de Angola no Reino de Espanha',
      description: 'A Embaixada da República de Angola em Madrid é a representação diplomática da República de Angola junto ao Estado espanhol, com jurisdição em todo o território do Reino de Espanha.',
      contact_embassy: 'Contactar a Embaixada',
      citizens_spain: 'Cidadãos Angolanos em Espanha',
      diplomatic_since: 'Relações Diplomáticas desde',
      consular_services_count: 'Serviços Consulares',
      head_of_mission: 'Chefe da Missão',
      the_ambassador: 'A Embaixadora',
      ambassador_label: 'Embaixadora',
      biography: 'Biografia',
      ambassador_message: 'Mensagem da Embaixadora',
      contact: 'Contactar',
      diplomatic_history: 'História Diplomática',
      former_ambassadors: 'Antigos Embaixadores',
      former_ambassadors_desc: 'Os representantes que construíram as relações Angola–Espanha',
      our_mission: 'A Nossa Missão',
      diplomatic_mission: 'Missão Diplomática',
      diplomatic_mission_desc: 'Representar e defender os interesses da República de Angola junto ao Estado espanhol, promovendo relações bilaterais de amizade e cooperação.',
      consular_protection: 'Protecção Consular',
      consular_protection_desc: 'Proteger os direitos e interesses dos cidadãos angolanos residentes em Espanha e facilitar a emissão de documentos consulares.',
      community_support: 'Apoio à Comunidade',
      community_support_desc: 'Apoiar a comunidade angolana residente em Espanha nas suas necessidades consulares, administrativas e de integração.',
    },
    services: {
      title: 'Serviços Consulares',
      subtitle: 'Informações completas sobre todos os serviços prestados pela Embaixada de Angola em Espanha, incluindo documentos necessários, taxas e prazos de processamento.',
      requirements: 'Documentos necessários',
      fee: 'Taxa', processing: 'Prazo',
      book: 'Agendar / Pagar',
      all_services: 'Todos os Serviços',
      schedule_appointment: 'Agendar Consulta',
      consular_card_online: 'Cartão Consular Online',
      required_docs_checklist: 'Documentos Necessários (Checklist)',
      print_checklist: 'Imprimir checklist',
      important_info: 'Informação Importante',
      info_original_copy: 'Todos os documentos devem ser apresentados em original e cópia',
      info_appointment: 'É necessário agendamento prévio para este serviço',
      info_payment: 'O pagamento pode ser efectuado online ou presencialmente',
      pay_fee_online: 'Pagar Taxa Online',
      need_help: 'Precisa de Ajuda?',
      need_help_desc: 'Se tiver dúvidas sobre os serviços consulares ou documentos necessários, não hesite em contactar-nos.',
      opening_hours: 'Horário de Atendimento',
      weekdays: 'Segunda a Sexta',
      weekends: 'Sábado e Domingo',
      closed: 'Encerrado',
      appointment_recommended: 'Recomendamos agendamento prévio para todos os serviços',
      cat_documentos: 'Documentos de Identificação',
      cat_vistos: 'Vistos e Autorizações',
      cat_certidoes: 'Certidões e Registos',
      cat_notarial: 'Serviços Notariais',
    },
    news: {
      title: 'Notícias & Revista Digital',
      subtitle: 'Acompanhe as últimas notícias da Embaixada e da comunidade angolana em Espanha',
      search_placeholder: 'Pesquisar notícias...',
      all_categories: 'Todas as categorias',
      no_results: 'Nenhuma notícia encontrada.',
    },
    events: {
      title: 'Próximos Eventos',
      subtitle: 'Agenda de eventos da Embaixada de Angola em Espanha',
      featured: 'Evento em Destaque',
      other_events: 'Outros Eventos',
      no_events: 'Nenhum evento disponível.',
      anniversary: 'ANIVERSÁRIO',
    },
    faq: {
      title: 'Perguntas Frequentes',
      subtitle: 'Encontre respostas às suas dúvidas mais comuns',
      search_placeholder: 'Pesquisar perguntas...',
      all_categories: 'Todas as categorias',
      no_results: 'Nenhuma pergunta encontrada.',
      not_found: 'Não encontrou resposta?',
      not_found_desc: 'A nossa equipa está disponível para o ajudar.',
      contact_embassy: 'Contactar a Embaixada',
    },
    contact: {
      title: 'Contactos',
      subtitle: 'Como chegar e como nos contactar',
      address: 'Morada', phone: 'Telefone', email: 'Email', hours: 'Horários',
      emergency: 'Emergência (24h)',
      emergency_desc: 'Disponível 24 horas, 7 dias por semana',
      send_message: 'Enviar Mensagem',
      name: 'Nome', message: 'Mensagem', subject: 'Assunto',
      your_name: 'Seu nome', your_email: 'seu@email.com',
      subject_placeholder: 'Assunto da mensagem',
      message_placeholder: 'Escreva a sua mensagem...',
      message_sent: 'Mensagem enviada! Responderemos em breve.',
      weekdays_hours: 'Segunda a Sexta: 09h – 15h',
      weekends_closed: 'Fins de semana e feriados: Encerrado',
      social_media: 'Redes Sociais',
      departments: 'Contactos por Sector',
      dept_ambassador: 'Gabinete da Embaixadora',
      dept_ambassador_desc: 'Assuntos diplomáticos e institucionais',
      dept_consular: 'Sector Consular',
      dept_consular_desc: 'Passaportes, vistos, certidões e documentos',
      dept_communication: 'Sector da Comunicação',
      dept_communication_desc: 'Imprensa, eventos e relações públicas',
      dept_economic: 'Sector Económico e Comercial',
      dept_economic_desc: 'Negócios, investimentos e cooperação',
      dept_admin: 'Sector Administrativo',
      dept_admin_desc: 'Assuntos administrativos gerais',
    },
    payments: {
      title: 'Pagamento de Taxas Consulares',
      subtitle: 'Pague as suas taxas consulares de forma segura online',
      select_service: 'Selecione o serviço',
      your_name: 'O seu nome completo',
      your_email: 'O seu email',
      notes: 'Notas adicionais (opcional)',
      pay_now: 'Pagar Agora',
      success_title: 'Pagamento Confirmado!',
      success_msg: 'O seu pagamento foi processado com sucesso. Receberá um email de confirmação.',
      cancel_msg: 'O pagamento foi cancelado. Tente novamente.',
      processing: 'A processar...',
    },
    auth: {
      login_title: 'Entrar', register_title: 'Criar Conta',
      email: 'Email', password: 'Senha', full_name: 'Nome Completo',
      username: 'Nome de utilizador', confirm_password: 'Confirmar Senha',
      forgot_password: 'Esqueceu a senha?', no_account: 'Nao tem conta?',
      have_account: 'Ja tem conta?', login_btn: 'Entrar', register_btn: 'Registar',
    },
    backoffice: {
      dashboard: 'Painel', articles: 'Artigos', users: 'Utilizadores',
      categories: 'Categorias', payments: 'Pagamentos', settings: 'Configuracoes',
      new_article: 'Novo Artigo', edit_article: 'Editar Artigo',
      total_users: 'Total de Utilizadores', total_articles: 'Total de Artigos',
      published: 'Publicados', pending: 'Pendentes', revenue: 'Receita Total',
    },
  },
  es: {
    nav: {
      home: 'Inicio', about: 'Sobre', services: 'Servicios', news: 'Noticias',
      events: 'Eventos', faq: 'FAQ', contact: 'Contactos', payments: 'Tasas',
      login: 'Entrar', logout: 'Salir', backoffice: 'Backoffice', register: 'Registrarse',
      emergency: 'Emergencia Consular', documents: 'Documentos',
      embassy: 'La Embajada',
      embassy_desc: 'Conozca la mision y estructura de la embajada',
      diplomatic_corps: 'Cuerpo Diplomatico',
      diplomatic_corps_desc: 'Embajadora y equipo diplomatico',
      consular_services: 'Servicios Consulares',
      consulate: 'El Consulado',
      angola_spain: 'Angola-Espana',
      investment: 'Inversion',
      invest_angola: 'Invertir en Angola',
      invest_angola_desc: 'Oportunidades e incentivos a la inversion',
      business_opportunities: 'Oportunidades de Negocio',
      business_opportunities_desc: 'Sectores estrategicos y alianzas',
      bilateral_relations: 'Relaciones Bilaterales',
      bilateral_relations_desc: 'Cooperacion Angola-Espana',
      news_events: 'Noticias y Eventos',
    },
    home: {
      hero_title: 'Embajada de Angola en Espana',
      hero_subtitle: 'Al servicio de los ciudadanos angolenos y de las relaciones bilaterales entre Angola y Espana',
      hero_btn1: 'Servicios Consulares', hero_btn2: 'Pagar Tasas',
      services_title: 'Servicios Consulares', news_title: 'Ultimas Noticias',
      events_title: 'Proximos Eventos', hours_title: 'Horario de Atencion',
      view_all_services: 'Ver todos los servicios',
      schedule_appointment: 'Agendar Cita',
      schedule_desc: 'Reserve su cita online',
      consular_card: 'Tarjeta Consular',
      consular_card_desc: 'Solicite su tarjeta online',
      consular_services: 'Servicios Consulares',
      consular_services_desc: 'Consulte todos los servicios',
      read_article: 'Leer articulo',
    },
    common: {
      read_more: 'Leer mas', view_all: 'Ver todos', loading: 'Cargando...',
      save: 'Guardar', cancel: 'Cancelar', delete: 'Eliminar', edit: 'Editar',
      create: 'Crear', submit: 'Enviar', publish: 'Publicar', draft: 'Borrador',
      approve: 'Aprobar', reject: 'Rechazar', search: 'Buscar',
      date: 'Fecha', author: 'Autor', category: 'Categoria', status: 'Estado',
      back: 'Volver', next: 'Siguiente', previous: 'Anterior',
      confirm_delete: 'Esta seguro de que desea eliminar?', yes: 'Si', no: 'No',
      required: 'Requerido', success: 'Exito', error: 'Error',
      no_results: 'Ningun resultado encontrado.',
      sending: 'Enviando...', free_entry: 'ENTRADA GRATUITA',
      learn_more: 'Saber Mas', other: 'Otros',
    },
    embassy: {
      overline: 'Republica de Angola',
      title: 'La Embajada',
      subtitle: 'Representacion diplomatica de Angola en el Reino de Espana',
      stat_citizens: 'Ciudadanos Angolenos en Espana',
      stat_since: 'Relaciones Diplomaticas desde',
      stat_services: 'Servicios Consulares',
      about_overline: 'Sobre la Embajada',
      about_title: 'Nuestra Historia y Mision',
      about_p1: 'La Embajada de la Republica de Angola en Madrid es la representacion diplomatica oficial de la Republica de Angola ante el Estado espanol, con jurisdiccion en todo el territorio del Reino de Espana.',
      about_p2: 'Fundada en 1982, la mision diplomatica angolena en Espana ha desempenado un papel fundamental en el fortalecimiento de las relaciones bilaterales entre los dos paises.',
      about_p3: 'La Embajada presta servicios consulares esenciales a los ciudadanos angolenos residentes en Espana.',
      info_title: 'Informacion Practica',
      contact_btn: 'Contactar la Embajada',
      mission_title: 'Nuestra Mision',
      sectors_title: 'Sectores',
      sector_ambassador: 'Embajadora',
      sector_consular: 'Sector Consular',
      sector_consular_desc: 'Pasaportes, visados, certificados y todos los servicios consulares',
      sector_political: 'Sector Politico',
      sector_political_desc: 'Relaciones diplomaticas, cooperacion bilateral y asuntos politicos internacionales',
      sector_economic: 'Sector Economico y Comercial',
      sector_economic_desc: 'Promocion de inversiones, comercio bilateral y relaciones economicas',
      sector_communication: 'Sector de Comunicacion',
      sector_communication_desc: 'Prensa, eventos institucionales, relaciones publicas y comunicacion digital',
    },
    diplomatic: {
      overline: 'Cuerpo Diplomatico',
      title: 'Cuerpo Diplomatico',
      subtitle: 'El equipo diplomatico que representa a Angola en Espana',
      org_overline: 'Estructura Organizacional',
      org_title: 'Organigrama de la Embajada',
      org_subtitle: 'El equipo que sirve a la comunidad angolena en Espana',
      placeholder: 'Por designar',
    },
    angola_spain: {
      overline: 'Relaciones Internacionales',
      title: 'Angola - Espana',
      subtitle: 'Una alianza estrategica para el desarrollo mutuo',
      relations_overline: 'Alianza Estrategica',
      relations_title: 'Relaciones Angola-Espana',
      relations_p1: 'Angola y Espana mantienen relaciones diplomaticas desde 1975. La cooperacion se ha intensificado en diversas areas estrategicas.',
      relations_p2: 'La comunidad angolena en Espana, estimada en mas de 50 mil ciudadanos, constituye un puente vital entre los dos paises.',
      stat_year: 'Relaciones desde',
      stat_community: 'Comunidad Angolena',
      stat_agreements: 'Acuerdos Bilaterales',
      stat_sectors: 'Sectores de Cooperacion',
      areas_title: 'Areas de Cooperacion',
      area_economy: 'Economia y Comercio',
      area_economy_desc: 'Intercambio comercial e inversiones bilaterales.',
      area_culture: 'Cultura e Idioma',
      area_culture_desc: 'Promocion cultural e intercambios entre los dos paises.',
      area_education: 'Educacion y Formacion',
      area_education_desc: 'Becas, intercambio academico y cooperacion universitaria.',
      area_energy: 'Energia y Recursos',
      area_energy_desc: 'Cooperacion en sectores energetico y de recursos naturales.',
      area_politics: 'Cooperacion Politica',
      area_politics_desc: 'Dialogo politico y posiciones conjuntas en foros internacionales.',
      area_tourism: 'Turismo',
      area_tourism_desc: 'Promocion turistica bilateral.',
      cta_title: 'Fortalecer las Relaciones',
      cta_desc: 'Descubra oportunidades de inversion y cooperacion entre Angola y Espana.',
      cta_invest: 'Invertir en Angola',
      cta_contact: 'Contactar la Embajada',
    },
    invest: {
      overline: 'Inversion',
      title: 'Invertir en Angola',
      subtitle: 'Descubra las oportunidades de inversion en uno de los paises con mayor crecimiento en Africa',
      why_title: 'Por que Invertir en Angola?',
      why_desc: 'Angola es la tercera mayor economia del Africa Subsahariana, con vastos recursos naturales y un programa de diversificacion economica.',
      advantages_title: 'Ventajas Competitivas',
      adv_1: 'Tercera mayor economia del Africa Subsahariana',
      adv_2: 'Recursos naturales abundantes',
      adv_3: 'Poblacion joven y dinamica',
      adv_4: 'Incentivos fiscales y zonas economicas especiales',
      adv_5: 'Ubicacion estrategica en la costa atlantica africana',
      adv_6: 'Programas de diversificacion economica',
      sectors_title: 'Sectores Estrategicos',
      sector_oil: 'Petroleo y Gas',
      sector_oil_desc: 'Segundo mayor productor de petroleo en Africa.',
      sector_mining: 'Mineria y Diamantes',
      sector_mining_desc: 'Cuarto mayor productor mundial de diamantes.',
      sector_agri: 'Agricultura',
      sector_agri_desc: 'Tierras arables abundantes con gran potencial agricola.',
      sector_tech: 'Tecnologia',
      sector_tech_desc: 'Sector en rapida expansion con oportunidades en telecomunicaciones y fintech.',
      sector_infra: 'Infraestructuras',
      sector_infra_desc: 'Inversiones en transportes, energia y vivienda.',
      sector_tourism: 'Turismo',
      sector_tourism_desc: 'Potencial inexplorado con paisajes unicos.',
      cta_title: 'Listo para Invertir?',
      cta_desc: 'La Seccion Economica y Comercial de la Embajada esta disponible para apoyar su proyecto.',
      cta_opportunities: 'Ver Oportunidades',
      cta_contact: 'Contactarnos',
    },
    opportunities: {
      overline: 'Oportunidades',
      title: 'Oportunidades de Negocio',
      subtitle: 'Sectores estrategicos y oportunidades para inversores y empresas',
      intro_title: 'Oportunidades en Angola',
      intro_desc: 'El Gobierno de Angola ha implementado reformas estructurales significativas para atraer inversion extranjera.',
      sectors_title: 'Sectores con Oportunidades',
      opp_energy: 'Energia y Petroleo',
      opp_energy_desc: 'Concesiones petroliferas y energia renovable.',
      opp_construction: 'Construccion e Inmobiliario',
      opp_construction_desc: 'Proyectos habitacionales e infraestructuras publicas.',
      opp_agriculture: 'Agroindustria',
      opp_agriculture_desc: 'Produccion alimentaria y exportacion de productos tropicales.',
      opp_technology: 'Tecnologia e Innovacion',
      opp_technology_desc: 'Telecomunicaciones, pagos digitales y servicios tecnologicos.',
      opp_finance: 'Servicios Financieros',
      opp_finance_desc: 'Banca, seguros y micro-finanzas.',
      opp_services: 'Servicios y Consultoria',
      opp_services_desc: 'Consultoria juridica, auditoria y servicios empresariales.',
      links_title: 'Enlaces Utiles',
      cta_title: 'Interesado en una Oportunidad?',
      cta_desc: 'Contacte la Seccion Economica y Comercial de la Embajada.',
      cta_contact: 'Contactar la Embajada',
    },
    bilateral: {
      overline: 'Diplomacia',
      title: 'Relaciones Bilaterales',
      subtitle: 'La historia y cooperacion entre Angola y Espana',
      overview_title: 'Vision General',
      overview_p1: 'Las relaciones bilaterales entre Angola y Espana se caracterizan por la amistad y la cooperacion estrategica.',
      overview_p2: 'A lo largo de las decadas, ambos paises han firmado acuerdos de cooperacion en los ambitos economico, cultural y educativo.',
      timeline_title: 'Cronologia',
      timeline_1975: 'Independencia de Angola. Espana reconoce el nuevo Estado.',
      timeline_1982: 'Apertura de la primera Embajada de Angola en Madrid.',
      timeline_2000: 'Firma de acuerdos de cooperacion economica y comercial.',
      timeline_2010: 'Intensificacion de las relaciones economicas e inversiones bilaterales.',
      timeline_2025: 'Nombramiento de la nueva Embajadora y refuerzo de la cooperacion estrategica.',
      cooperation_title: 'Areas de Cooperacion',
      coop_economy: 'Economia y Comercio',
      coop_culture: 'Cultura y Educacion',
      coop_education: 'Ciencia y Tecnologia',
      coop_legal: 'Cooperacion Juridica',
      cta_title: 'Fortalecer la Alianza',
      cta_desc: 'La Embajada trabaja diariamente para profundizar las relaciones entre Angola y Espana.',
      cta_invest: 'Invertir en Angola',
      cta_relations: 'Angola-Espana',
    },
    news_events: {
      overline: 'Comunicacion',
      title: 'Noticias y Eventos',
      subtitle: 'Siga las ultimas noticias y eventos de la Embajada de Angola en Espana',
      featured_news: 'Noticias Destacadas',
      articles: 'Articulos y Publicaciones',
      events_section: 'Proximos Eventos',
    },
    about: {
      republic: 'Republica de Angola',
      title: 'Embajada de Angola en el Reino de Espana',
      description: 'La Embajada de la Republica de Angola en Madrid es la representacion diplomatica de la Republica de Angola ante el Estado espanol.',
      contact_embassy: 'Contactar la Embajada',
      citizens_spain: 'Ciudadanos Angolenos en Espana',
      diplomatic_since: 'Relaciones Diplomaticas desde',
      consular_services_count: 'Servicios Consulares',
      head_of_mission: 'Jefe de Mision',
      the_ambassador: 'La Embajadora',
      ambassador_label: 'Embajadora',
      biography: 'Biografia',
      ambassador_message: 'Mensaje de la Embajadora',
      contact: 'Contactar',
      diplomatic_history: 'Historia Diplomatica',
      former_ambassadors: 'Antiguos Embajadores',
      former_ambassadors_desc: 'Los representantes que construyeron las relaciones Angola-Espana',
      our_mission: 'Nuestra Mision',
      diplomatic_mission: 'Mision Diplomatica',
      diplomatic_mission_desc: 'Representar y defender los intereses de la Republica de Angola ante el Estado espanol.',
      consular_protection: 'Proteccion Consular',
      consular_protection_desc: 'Proteger los derechos e intereses de los ciudadanos angolenos residentes en Espana.',
      community_support: 'Apoyo a la Comunidad',
      community_support_desc: 'Apoyar a la comunidad angolena residente en Espana.',
    },
    services: {
      title: 'Servicios Consulares',
      subtitle: 'Informacion completa sobre todos los servicios prestados por la Embajada de Angola en Espana.',
      requirements: 'Documentos necesarios',
      fee: 'Tasa', processing: 'Plazo',
      book: 'Agendar / Pagar',
      all_services: 'Todos los Servicios',
      schedule_appointment: 'Agendar Cita',
      consular_card_online: 'Tarjeta Consular Online',
      required_docs_checklist: 'Documentos Necesarios (Checklist)',
      print_checklist: 'Imprimir checklist',
      important_info: 'Informacion Importante',
      info_original_copy: 'Todos los documentos deben presentarse en original y copia',
      info_appointment: 'Es necesaria cita previa para este servicio',
      info_payment: 'El pago puede realizarse online o presencialmente',
      pay_fee_online: 'Pagar Tasa Online',
      need_help: 'Necesita Ayuda?',
      need_help_desc: 'Si tiene dudas, no dude en contactarnos.',
      opening_hours: 'Horario de Atencion',
      weekdays: 'Lunes a Viernes',
      weekends: 'Sabado y Domingo',
      closed: 'Cerrado',
      appointment_recommended: 'Recomendamos cita previa para todos los servicios',
      cat_documentos: 'Documentos de Identificacion',
      cat_vistos: 'Visados y Autorizaciones',
      cat_certidoes: 'Certificados y Registros',
      cat_notarial: 'Servicios Notariales',
    },
    news: {
      title: 'Noticias & Revista Digital',
      subtitle: 'Siga las ultimas noticias de la Embajada y de la comunidad angolena en Espana',
      search_placeholder: 'Buscar noticias...', all_categories: 'Todas las categorias',
      no_results: 'No se encontraron noticias.',
    },
    events: {
      title: 'Proximos Eventos',
      subtitle: 'Agenda de eventos de la Embajada de Angola en Espana',
      featured: 'Evento Destacado',
      other_events: 'Otros Eventos',
      no_events: 'Ningun otro evento disponible.',
      anniversary: 'ANIVERSARIO',
    },
    faq: {
      title: 'Preguntas Frecuentes',
      subtitle: 'Encuentre respuestas a sus dudas',
      search_placeholder: 'Buscar preguntas...',
      all_categories: 'Todas las categorias',
      no_results: 'Ninguna pregunta encontrada.',
      not_found: 'No encontro respuesta?',
      not_found_desc: 'Nuestro equipo esta disponible para ayudarle.',
      contact_embassy: 'Contactar la Embajada',
    },
    contact: {
      title: 'Contactos',
      subtitle: 'Como llegar y como contactarnos',
      address: 'Direccion', phone: 'Telefono', email: 'Email', hours: 'Horarios',
      emergency: 'Emergencia (24h)',
      emergency_desc: 'Disponible 24 horas, 7 dias a la semana',
      send_message: 'Enviar Mensaje',
      name: 'Nombre', message: 'Mensaje', subject: 'Asunto',
      your_name: 'Su nombre', your_email: 'su@email.com',
      subject_placeholder: 'Asunto del mensaje',
      message_placeholder: 'Escriba su mensaje...',
      message_sent: 'Mensaje enviado! Responderemos pronto.',
      weekdays_hours: 'Lunes a Viernes: 09h - 15h',
      weekends_closed: 'Fines de semana y festivos: Cerrado',
      social_media: 'Redes Sociales',
      departments: 'Contactos por Departamento',
      dept_ambassador: 'Gabinete del Embajador',
      dept_ambassador_desc: 'Asuntos diplomaticos e institucionales',
      dept_consular: 'Seccion Consular',
      dept_consular_desc: 'Pasaportes, visados, certificados y documentos',
      dept_communication: 'Seccion de Comunicacion',
      dept_communication_desc: 'Prensa, eventos y relaciones publicas',
      dept_economic: 'Seccion Economica y Comercial',
      dept_economic_desc: 'Negocios, inversiones y cooperacion',
      dept_admin: 'Seccion Administrativa',
      dept_admin_desc: 'Asuntos administrativos generales',
    },
    payments: {
      title: 'Pago de Tasas Consulares',
      subtitle: 'Pague sus tasas consulares de forma segura online',
      select_service: 'Seleccione el servicio',
      your_name: 'Su nombre completo', your_email: 'Su email',
      notes: 'Notas adicionales (opcional)', pay_now: 'Pagar Ahora',
      success_title: 'Pago Confirmado!',
      success_msg: 'Su pago fue procesado exitosamente.',
      cancel_msg: 'El pago fue cancelado. Intentelo de nuevo.',
      processing: 'Procesando...',
    },
    auth: {
      login_title: 'Iniciar Sesion', register_title: 'Crear Cuenta',
      email: 'Email', password: 'Contrasena', full_name: 'Nombre Completo',
      username: 'Nombre de usuario', login_btn: 'Entrar', register_btn: 'Registrarse',
    },
    backoffice: {
      dashboard: 'Panel', articles: 'Articulos', users: 'Usuarios',
      categories: 'Categorias', payments: 'Pagos', settings: 'Configuracion',
      new_article: 'Nuevo Articulo', edit_article: 'Editar Articulo',
    },
  },
  en: {
    nav: {
      home: 'Home', about: 'About', services: 'Services', news: 'News',
      events: 'Events', faq: 'FAQ', contact: 'Contact', payments: 'Fees',
      login: 'Login', logout: 'Logout', backoffice: 'Backoffice', register: 'Register',
      emergency: 'Consular Emergency', documents: 'Documents',
      embassy: 'The Embassy',
      embassy_desc: 'Learn about the mission and structure',
      diplomatic_corps: 'Diplomatic Corps',
      diplomatic_corps_desc: 'Ambassador and diplomatic team',
      consular_services: 'Consular Services',
      angola_spain: 'Angola-Spain',
      investment: 'Investment',
      invest_angola: 'Invest in Angola',
      invest_angola_desc: 'Opportunities and investment incentives',
      business_opportunities: 'Business Opportunities',
      business_opportunities_desc: 'Strategic sectors and partnerships',
      bilateral_relations: 'Bilateral Relations',
      bilateral_relations_desc: 'Angola-Spain cooperation',
      news_events: 'News & Events',
    },
    home: {
      hero_title: 'Embassy of Angola in Spain',
      hero_subtitle: 'Serving Angolan citizens and fostering bilateral relations between Angola and Spain',
      hero_btn1: 'Consular Services', hero_btn2: 'Pay Fees',
      services_title: 'Consular Services', news_title: 'Latest News',
      events_title: 'Upcoming Events', hours_title: 'Opening Hours',
      view_all_services: 'View all services',
      schedule_appointment: 'Schedule Appointment',
      schedule_desc: 'Book your appointment online',
      consular_card: 'Consular Card',
      consular_card_desc: 'Request your card online',
      consular_services: 'Consular Services',
      consular_services_desc: 'Browse all services',
      read_article: 'Read article',
    },
    common: {
      read_more: 'Read more', view_all: 'View all', loading: 'Loading...',
      save: 'Save', cancel: 'Cancel', delete: 'Delete', edit: 'Edit',
      create: 'Create', submit: 'Submit', publish: 'Publish', draft: 'Draft',
      approve: 'Approve', reject: 'Reject', search: 'Search',
      date: 'Date', author: 'Author', category: 'Category', status: 'Status',
      back: 'Back', next: 'Next', previous: 'Previous',
      confirm_delete: 'Are you sure you want to delete?', yes: 'Yes', no: 'No',
      required: 'Required', success: 'Success', error: 'Error',
      no_results: 'No results found.',
      sending: 'Sending...', free_entry: 'FREE ENTRY',
      learn_more: 'Learn More', other: 'Others',
    },
    embassy: {
      overline: 'Republic of Angola',
      title: 'The Embassy',
      subtitle: 'Diplomatic representation of Angola in the Kingdom of Spain',
      stat_citizens: 'Angolan Citizens in Spain',
      stat_since: 'Diplomatic Relations since',
      stat_services: 'Consular Services',
      about_overline: 'About the Embassy',
      about_title: 'Our History and Mission',
      about_p1: 'The Embassy of the Republic of Angola in Madrid is the official diplomatic representation of the Republic of Angola to the Spanish State, with jurisdiction throughout the territory of the Kingdom of Spain.',
      about_p2: 'Founded in 1982, the Angolan diplomatic mission in Spain has played a fundamental role in strengthening bilateral relations between the two countries.',
      about_p3: 'The Embassy provides essential consular services to Angolan citizens residing in Spain.',
      info_title: 'Practical Information',
      contact_btn: 'Contact the Embassy',
      mission_title: 'Our Mission',
      departments_title: 'Departments',
    },
    diplomatic: {
      overline: 'Diplomatic Corps',
      title: 'Diplomatic Corps',
      subtitle: 'The diplomatic team representing Angola in Spain',
    },
    angola_spain: {
      overline: 'International Relations',
      title: 'Angola - Spain',
      subtitle: 'A strategic partnership for mutual development',
      relations_overline: 'Strategic Partnership',
      relations_title: 'Angola-Spain Relations',
      relations_p1: 'Angola and Spain have maintained diplomatic relations since 1975. Cooperation has intensified across several strategic areas.',
      relations_p2: 'The Angolan community in Spain, estimated at over 50 thousand citizens, constitutes a vital bridge between the two countries.',
      stat_year: 'Relations since',
      stat_community: 'Angolan Community',
      stat_agreements: 'Bilateral Agreements',
      stat_sectors: 'Cooperation Sectors',
      areas_title: 'Areas of Cooperation',
      area_economy: 'Economy & Trade',
      area_economy_desc: 'Commercial exchange and bilateral investments.',
      area_culture: 'Culture & Language',
      area_culture_desc: 'Cultural promotion and exchanges between both countries.',
      area_education: 'Education & Training',
      area_education_desc: 'Scholarship programs, academic exchange and university cooperation.',
      area_energy: 'Energy & Resources',
      area_energy_desc: 'Cooperation in energy, oil and natural resources sectors.',
      area_politics: 'Political Cooperation',
      area_politics_desc: 'Political dialogue and joint positions in international forums.',
      area_tourism: 'Tourism',
      area_tourism_desc: 'Bilateral tourism promotion and travel facilitation.',
      cta_title: 'Strengthen Relations',
      cta_desc: 'Discover investment and cooperation opportunities between Angola and Spain.',
      cta_invest: 'Invest in Angola',
      cta_contact: 'Contact the Embassy',
    },
    invest: {
      overline: 'Investment',
      title: 'Invest in Angola',
      subtitle: 'Discover investment opportunities in one of Africa\'s fastest growing countries',
      why_title: 'Why Invest in Angola?',
      why_desc: 'Angola is the third largest economy in Sub-Saharan Africa, with vast natural resources, a young population, and an ambitious economic diversification program.',
      advantages_title: 'Competitive Advantages',
      adv_1: 'Third largest economy in Sub-Saharan Africa',
      adv_2: 'Abundant natural resources (oil, diamonds, minerals)',
      adv_3: 'Young and dynamic population (60% under 25)',
      adv_4: 'Tax incentives and special economic zones',
      adv_5: 'Strategic location on the African Atlantic coast',
      adv_6: 'Ongoing economic diversification programs',
      sectors_title: 'Strategic Sectors',
      sector_oil: 'Oil & Gas',
      sector_oil_desc: 'Second largest oil producer in Africa.',
      sector_mining: 'Mining & Diamonds',
      sector_mining_desc: 'Fourth largest diamond producer worldwide.',
      sector_agri: 'Agriculture',
      sector_agri_desc: 'Abundant arable land with significant agricultural potential.',
      sector_tech: 'Technology',
      sector_tech_desc: 'Rapidly expanding sector with opportunities in telecoms and fintech.',
      sector_infra: 'Infrastructure',
      sector_infra_desc: 'Significant investments in transport, energy and housing.',
      sector_tourism: 'Tourism',
      sector_tourism_desc: 'Untapped potential with unique landscapes and diverse wildlife.',
      cta_title: 'Ready to Invest?',
      cta_desc: 'The Economic and Commercial Section is available to support your investment project.',
      cta_opportunities: 'View Opportunities',
      cta_contact: 'Contact Us',
    },
    opportunities: {
      overline: 'Opportunities',
      title: 'Business Opportunities',
      subtitle: 'Strategic sectors and opportunities for investors and businesses',
      intro_title: 'Opportunities in Angola',
      intro_desc: 'The Government of Angola has implemented significant structural reforms to attract foreign investment.',
      sectors_title: 'Sectors with Opportunities',
      opp_energy: 'Energy & Oil',
      opp_energy_desc: 'Oil concessions and renewable energy.',
      opp_construction: 'Construction & Real Estate',
      opp_construction_desc: 'Housing projects and public infrastructure.',
      opp_agriculture: 'Agro-industry',
      opp_agriculture_desc: 'Food production and tropical product exports.',
      opp_technology: 'Technology & Innovation',
      opp_technology_desc: 'Telecommunications, digital payments and tech services.',
      opp_finance: 'Financial Services',
      opp_finance_desc: 'Banking, insurance and micro-finance.',
      opp_services: 'Services & Consulting',
      opp_services_desc: 'Legal consulting, auditing and business services.',
      links_title: 'Useful Links',
      cta_title: 'Interested in an Opportunity?',
      cta_desc: 'Contact the Economic and Commercial Section for more information.',
      cta_contact: 'Contact the Embassy',
    },
    bilateral: {
      overline: 'Diplomacy',
      title: 'Bilateral Relations',
      subtitle: 'The history and cooperation between Angola and Spain',
      overview_title: 'Overview',
      overview_p1: 'Bilateral relations between Angola and Spain are characterized by friendship and strategic cooperation.',
      overview_p2: 'Over the decades, both countries have signed cooperation agreements in economic, cultural and educational fields.',
      timeline_title: 'Timeline',
      timeline_1975: 'Independence of Angola. Spain recognizes the new State.',
      timeline_1982: 'Opening of the first Angolan Embassy in Madrid.',
      timeline_2000: 'Signing of economic and commercial cooperation agreements.',
      timeline_2010: 'Intensification of economic relations and bilateral investments.',
      timeline_2025: 'Appointment of new Ambassador and strengthening of strategic cooperation.',
      cooperation_title: 'Areas of Cooperation',
      coop_economy: 'Economy & Trade',
      coop_culture: 'Culture & Education',
      coop_education: 'Science & Technology',
      coop_legal: 'Legal Cooperation',
      cta_title: 'Strengthen the Partnership',
      cta_desc: 'The Embassy works daily to deepen relations between Angola and Spain.',
      cta_invest: 'Invest in Angola',
      cta_relations: 'Angola-Spain',
    },
    news_events: {
      overline: 'Communication',
      title: 'News & Events',
      subtitle: 'Follow the latest news and events from the Embassy of Angola in Spain',
      featured_news: 'Featured News',
      articles: 'Articles & Publications',
      events_section: 'Upcoming Events',
    },
    about: {
      republic: 'Republic of Angola',
      title: 'Embassy of Angola in the Kingdom of Spain',
      description: 'The Embassy of the Republic of Angola in Madrid is the diplomatic representation of the Republic of Angola to the Spanish State.',
      contact_embassy: 'Contact the Embassy',
      citizens_spain: 'Angolan Citizens in Spain',
      diplomatic_since: 'Diplomatic Relations since',
      consular_services_count: 'Consular Services',
      head_of_mission: 'Head of Mission',
      the_ambassador: 'The Ambassador',
      ambassador_label: 'Ambassador',
      biography: 'Biography',
      ambassador_message: 'Message from the Ambassador',
      contact: 'Contact',
      diplomatic_history: 'Diplomatic History',
      former_ambassadors: 'Former Ambassadors',
      former_ambassadors_desc: 'The representatives who built the Angola-Spain relations',
      our_mission: 'Our Mission',
      diplomatic_mission: 'Diplomatic Mission',
      diplomatic_mission_desc: 'Represent and defend the interests of the Republic of Angola before the Spanish State.',
      consular_protection: 'Consular Protection',
      consular_protection_desc: 'Protect the rights and interests of Angolan citizens residing in Spain.',
      community_support: 'Community Support',
      community_support_desc: 'Support the Angolan community in their consular and integration needs.',
    },
    services: {
      title: 'Consular Services',
      subtitle: 'Complete information about all services provided by the Embassy of Angola in Spain.',
      requirements: 'Required documents',
      fee: 'Fee', processing: 'Processing time',
      book: 'Schedule / Pay',
      all_services: 'All Services',
      schedule_appointment: 'Schedule Appointment',
      consular_card_online: 'Consular Card Online',
      required_docs_checklist: 'Required Documents (Checklist)',
      print_checklist: 'Print checklist',
      important_info: 'Important Information',
      info_original_copy: 'All documents must be presented in original and copy',
      info_appointment: 'Prior appointment is required',
      info_payment: 'Payment can be made online or in person',
      pay_fee_online: 'Pay Fee Online',
      need_help: 'Need Help?',
      need_help_desc: 'If you have questions, do not hesitate to contact us.',
      opening_hours: 'Opening Hours',
      weekdays: 'Monday to Friday',
      weekends: 'Saturday and Sunday',
      closed: 'Closed',
      appointment_recommended: 'We recommend prior appointment for all services',
      cat_documentos: 'Identification Documents',
      cat_vistos: 'Visas and Authorizations',
      cat_certidoes: 'Certificates and Records',
      cat_notarial: 'Notarial Services',
    },
    news: {
      title: 'News & Digital Magazine',
      subtitle: 'Follow the latest news from the Embassy and the Angolan community in Spain',
      search_placeholder: 'Search news...', all_categories: 'All categories',
      no_results: 'No news found.',
    },
    events: {
      title: 'Upcoming Events',
      subtitle: 'Events agenda of the Embassy of Angola in Spain',
      featured: 'Featured Event',
      other_events: 'Other Events',
      no_events: 'No other events available.',
      anniversary: 'ANNIVERSARY',
    },
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Find answers to your most common questions',
      search_placeholder: 'Search questions...',
      all_categories: 'All categories',
      no_results: 'No questions found.',
      not_found: 'Didn\'t find your answer?',
      not_found_desc: 'Our team is available to help you.',
      contact_embassy: 'Contact the Embassy',
    },
    contact: {
      title: 'Contact',
      subtitle: 'How to reach us',
      address: 'Address', phone: 'Phone', email: 'Email', hours: 'Hours',
      emergency: 'Emergency (24h)',
      emergency_desc: 'Available 24 hours, 7 days a week',
      send_message: 'Send Message',
      name: 'Name', message: 'Message', subject: 'Subject',
      your_name: 'Your name', your_email: 'your@email.com',
      subject_placeholder: 'Message subject',
      message_placeholder: 'Write your message...',
      message_sent: 'Message sent! We will respond shortly.',
      weekdays_hours: 'Monday to Friday: 09h - 15h',
      weekends_closed: 'Weekends and holidays: Closed',
      social_media: 'Social Media',
      departments: 'Contact by Department',
      dept_ambassador: 'Ambassador\'s Office',
      dept_ambassador_desc: 'Diplomatic and institutional affairs',
      dept_consular: 'Consular Section',
      dept_consular_desc: 'Passports, visas, certificates and documents',
      dept_communication: 'Communication Section',
      dept_communication_desc: 'Press, events and public relations',
      dept_economic: 'Economic and Commercial Section',
      dept_economic_desc: 'Business, investments and cooperation',
      dept_admin: 'Administrative Section',
      dept_admin_desc: 'General administrative affairs',
    },
    payments: {
      title: 'Consular Fee Payment',
      subtitle: 'Pay your consular fees securely online',
      select_service: 'Select service',
      your_name: 'Your full name', your_email: 'Your email',
      notes: 'Additional notes (optional)', pay_now: 'Pay Now',
      success_title: 'Payment Confirmed!',
      success_msg: 'Your payment was processed successfully.',
      cancel_msg: 'Payment was cancelled. Please try again.',
      processing: 'Processing...',
    },
    auth: {
      login_title: 'Login', register_title: 'Create Account',
      email: 'Email', password: 'Password', full_name: 'Full Name',
      username: 'Username', login_btn: 'Login', register_btn: 'Register',
    },
    backoffice: {
      dashboard: 'Dashboard', articles: 'Articles', users: 'Users',
      categories: 'Categories', payments: 'Payments', settings: 'Settings',
      new_article: 'New Article', edit_article: 'Edit Article',
    },
  },
};
